import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]

import { CircularIcon, Icon, NavigateNextIcon } from "../Icons";

import { AdvertisementList } from "@/data/index.type";
import { computed } from "@vue/reactivity";

interface AdvertPanelMenuProps {
  data: AdvertisementList;
  active: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvertPanelMenu',
  props: {
    data: null,
    active: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (event: "click", active: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data: AdvertisementList;
  active: string;
}

const validMenu = computed(() => Object.keys(props.data).filter((v) => props.data[v].length > 0));



const menu = computed(() => Object.keys(props.data));



const onClick = (index: number) => {
  if (menu.value.length === index) {
    emit("click", "");
    return;
  }
  if (validMenu.value.find((v) => menu.value[index] === v)) {
    emit("click", menu.value[index]);
  } else {
    onClick(index + 1);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(_ctx.$style['menu'])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        class: _normalizeClass({ active: __props.active === item }),
        onClick: ($event: any) => (onClick(index))
      }, [
        _createVNode(_unref(Icon), {
          size: 13,
          style: {"margin":"0 10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(CircularIcon))
          ]),
          _: 1
        }),
        _createElementVNode("span", null, " " + _toDisplayString((index + 1).toString().padStart(2, "0")) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(item), 1),
        _createVNode(_unref(Icon), {
          size: 32,
          style: {"margin-left":"auto","margin-right":"16px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NavigateNextIcon))
          ]),
          _: 1
        })
      ], 10, _hoisted_1))
    }), 128))
  ], 2))
}
}

})